// pages/Home.js
import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Methodology from '../components/Methodology';
import Contact from '../components/Contact';
import Differentiator from "./Differentiator";
import Commitment from "./Commitment";
import Vision from "./Vision";
import PortfolioSummary from "./PortfolioSummary";

const Home = () => {
    return (
        <div>
            <Hero/>
            <About/>
            <Services/>
            <Differentiator/>
            <Methodology/>
            <Commitment/>
            <Vision/>
            <PortfolioSummary/>
            <Contact/>
        </div>
    );
};

export default Home;
